import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import "../Logistics/Logistics.scss";

import ServiceToolbar from "../ServiceToolbar";

const TerminalManagement = () => {
  return (
    <>
      <div className="logistics-con">
        <div>
          <p className="title">
            <StaticImage
              className="service-badge"
              src="../../../images/svg/terminal-management.svg"
              width={45}
              quality={100}
              formats={["AUTO", "WEBP", "AVIF"]}
              alt="badge"
            />
            Terminal Development & Management
          </p>
        </div>

        <div className="d-flex flex-row service-ch-land">
          <div className="logistics-left">
            <div className="logistics">
              <StaticImage
                className="ch-img"
                src="../../../images/port-terminal.png"
                width={400}
                quality={100}
                formats={["AUTO", "WEBP", "AVIF"]}
                alt="about us"
              />

              <div className="text">
                {/* <p className="label">Stevedoring & Arrastre</p> */}
                <p>
                  Through structured development and management, we ensure each
                  facility reaches its maximum operational potential.
                </p>
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>

      <ServiceToolbar />
    </>
  );
};

export default TerminalManagement;
